// Preview toggle functionality
let isPreviewMode = false;

document.addEventListener('DOMContentLoaded', () => {
    // Create preview mode indicator
    const previewIndicator = document.createElement('div');
    previewIndicator.className = 'preview-mode-indicator';
    previewIndicator.textContent = 'Preview Mode';
    document.getElementById('map-container').appendChild(previewIndicator);

    // Replace "Check Preview" button with toggle switch in Map Options section
    const mapOptionsSection = document.querySelector('.map-options-section');
    if (mapOptionsSection) {
        // Create toggle container
        const toggleContainer = document.createElement('div');
        toggleContainer.className = 'preview-toggle-container flex items-center mb-2';
        
        // Create toggle label
        const toggleLabel = document.createElement('label');
        toggleLabel.htmlFor = 'toggle-preview-mode';
        toggleLabel.className = 'mr-2 text-xs font-medium text-gray-400';
        toggleLabel.textContent = 'Preview Mode';
        
        // Create toggle switch (iPhone style)
        const toggleSwitch = document.createElement('div');
        toggleSwitch.className = 'relative inline-block w-10 mr-2 align-middle select-none';
        toggleSwitch.innerHTML = `
            <input type="checkbox" id="toggle-preview-mode" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 border-gray-300 appearance-none cursor-pointer"/>
            <label for="toggle-preview-mode" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
        `;
        
        // Add toggle to container
        toggleContainer.appendChild(toggleLabel);
        toggleContainer.appendChild(toggleSwitch);
        
        // Add toggle container to Map Options section
        mapOptionsSection.appendChild(toggleContainer);
        
        // Remove the original "Check Preview" button
        const checkPreviewBtn = document.getElementById('check-preview-btn');
        if (checkPreviewBtn) {
            checkPreviewBtn.parentNode.removeChild(checkPreviewBtn);
        }
        
        // Add event listener to toggle switch
        document.getElementById('toggle-preview-mode').addEventListener('change', togglePreviewMode);
    }

    // Function to toggle preview mode
    function togglePreviewMode(e) {
        isPreviewMode = e.target.checked;
        
        const mapContainer = document.getElementById('map-container');
        
        if (isPreviewMode) {
            // Enter preview mode
            mapContainer.classList.add('map-controls-disabled');
            mapContainer.classList.add('map-preview-mode');
            
            // Disable map interactions
            disableMapInteractions();
        } else {
            // Exit preview mode
            mapContainer.classList.remove('map-controls-disabled');
            mapContainer.classList.remove('map-preview-mode');
            
            // Re-enable map interactions
            enableMapInteractions();
        }
    }

    // Function to disable map interactions
    function disableMapInteractions() {
        // Disable map controls
        if (map) {
            map.dragPan.disable();
            map.scrollZoom.disable();
            map.doubleClickZoom.disable();
            map.touchZoomRotate.disable();
            
            // Disable map click events
            map.off('click');
        }
    }

    // Function to enable map interactions
    function enableMapInteractions() {
        // Re-enable map controls
        if (map) {
            map.dragPan.enable();
            map.scrollZoom.enable();
            map.doubleClickZoom.enable();
            map.touchZoomRotate.enable();
        }
    }
});

console.log('mapTitlePreview:', mapTitlePreview);
console.log('mapSubtitlePreview:', mapSubtitlePreview);
console.log('markers:', markers);
markers.forEach((m, i) => {
  console.log(`Marker ${i}:`, m);
});
